module.exports = __webpack_public_path__ + "img/Basic.42ee8f1e.jpg";